module Cmd
open Fable.Core.JS
open Elmish
open Browser
open Fable.Core.JsInterop
type Options =
  { recaptchaSiteKey: string }

let ofConfig (address: string) =
  promise {
    let! response = Fetch.fetch address []
    let! (options:Options) = !!response.json()
    console.log("Configuration:", options)
    return options
  }

